import * as React from "react";

import { Box, Grid } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, getEllipsis, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_HIGHLIGHT_REQUEST_REVIEW_FILTER_VALIDATION_VALID, HIGHLIGHT_REQUEST_REVIEW_FILTER_VALIDATION } from "../../../../helper-functions/validation/highlightValidation";

import { getLanguage } from "../../../../config/language/language";
import { HIGHLIGHT_REQUEST_REVIEW_FILTER_OBJECT } from "../../../../config/constants/Constants";
import CustomSelection from "../../../../helper-components/form/CustomSelection";
import { querySelectHighlightRequests } from "../../../../helper-functions/api/highlightQueries";

/**
 * A form to update a author.
 */
export default function HighlightRequestReviewForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback, row: existingRow = {} } = props;

    const object = HIGHLIGHT_REQUEST_REVIEW_FILTER_OBJECT;
    const validation = HIGHLIGHT_REQUEST_REVIEW_FILTER_VALIDATION;
    const isValid = IS_HIGHLIGHT_REQUEST_REVIEW_FILTER_VALIDATION_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    // Initialize the temporary row object with existing values.
    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            _show_accordion: false,

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false // Required to allow editing input fields.
            }
        };

        setInsertObjectState(setRow, newRow);
    }, []);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newObj = JSON.parse(JSON.stringify(row));
        setValue(newObj, key, value);

        if (key === "_show_accordion") {
            if (!value) newObj.highlight_request_ids = []; // Reset selection if the accordion is closed.
        }

        validateRow(obj, validation, newObj);
        setInsertObjectState(setRow, newObj);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        const options = { row };
        callback(true, options);
    };

    const handleHighlightRequests = (selected = []) => {
        const ids = selected.map((el) => el.id);
        onChange(row, "highlight_request_ids", ids);
    };

    return (
        <Box className="box">
            <Grid container spacing={1}>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    <CustomInput name="_show_accordion" row={row} onChange={onChange} label="Filter queue by highlight requests" switch />
                </Grid>

                {/* Show accordion only if the switch is enabled. */}
                {row._show_accordion && (
                    <Grid item xs={12}>
                        <CustomSelection
                            {...props}
                            multiselect
                            callback={handleHighlightRequests}
                            query={querySelectHighlightRequests}
                            getPrimarySearchText={(el) => el?.name}
                            getSecondarySearchText={(el) => el?.description}
                            getPrimaryText={(el) => getEllipsis(el?.name, 50)}
                            getSecondaryText={(el) => getEllipsis(el?.description, 50)}
                        />
                    </Grid>
                )}
            </Grid>

            <CustomButton {...props} title={"Begin review"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
